import { useState } from 'react'

export function useModal() {
  const [modalState, setModalState] = useState(false)
  const [modalData, setModalData] = useState()
  function toggleModal(data = undefined) {
    setModalState(prevState => !prevState)
    setModalData(data)
  }

  return { modalState, modalData, toggleModal }
}
